import { useAuth } from '@shared/auth';
import { useDisclosure } from '@shared/hooks';
import { createContext, useMemo, useState } from 'react';

import { useAppMenu, useGetSidebarItem } from '../../hooks';
import type { SidebarContextInterface } from '../../types/sidebar';

const SidebarContext = createContext<SidebarContextInterface | undefined>(undefined);

interface SidebarProviderProps {
  children: React.ReactNode;
}

function SidebarProvider(props: Readonly<SidebarProviderProps>) {
  const { children } = props;

  const { userProfile } = useAuth();

  const appShell = useGetSidebarItem();
  const { appMenu } = useAppMenu({ appShell });

  const [isSecondarySidebarMounted, setIsSecondarySidebarMounted] = useState(false);
  const [isOpen, { open, close, toggle }] = useDisclosure(true);

  const user = useMemo(
    () => ({
      displayName: userProfile?.displayName ?? '',
    }),
    [userProfile],
  );

  const value = useMemo(
    () => ({
      appMenu,
      isOpen,
      open,
      close,
      toggle,
      isSecondarySidebarMounted,
      setIsSecondarySidebarMounted,
      user,
    }),
    [appMenu, isOpen, open, close, toggle, isSecondarySidebarMounted, user],
  );

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
}

export { SidebarContext, SidebarProvider };
